import { useRouter } from "@tanstack/react-router";
import omit from "lodash/omit";
import { DialogContent, V2Dialog } from "web-design-system";
import { AddSecondHolderForm } from "./add-second-holder/add-second-holder-form";

export function AddSecondHolderDialog() {
  const router = useRouter();

  const close = () => {
    router.navigate({
      to: ".",
      search: (prev) => omit(prev, ["modal", "client_id", "context"]),
      replace: true,
    });
  };

  return (
    <V2Dialog
      defaultOpen
      onOpenChange={(open) => {
        if (!open) close();
      }}
    >
      <DialogContent className="flex flex-col p-6 gap-3 space-y-0 w-160 h-137 max-w-none">
        <AddSecondHolderForm onClose={close} />
      </DialogContent>
    </V2Dialog>
  );
}
